import React, { useEffect, useState, useContext } from 'react';
import { Table, ConfigProvider } from 'antd';
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import moment from 'moment';
import { DataContext } from '../../init/getData';
import toast from 'react-hot-toast';
import { numberFormatter } from '../../components/formatters/numberFormatter';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { BiExport } from "react-icons/bi";
import exportToExcel from '../export/excel';
import ReportModal from '../../components/modals/reportModal';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';

const SalesSimpleTable = (props) => {
  const { filter, table, refreshTable, columnDefs, data, setData, tableFooter,
    height, getAllData, rowColor, setCheckedArray, selection, api, getExcelData, title, report, reportRef,
    selectedRowKeys, handleSelectAll } = props;

  const { userData } = useContext(DataContext);
  const [loading, setLoading] = useState(false);
  const [tableParams, setTableParams] = useState({ pagination: { current: 1, pageSize: 100 } });
  const [showReportModal, setShowReportModal] = useState(false);

  useEffect(() => {
    fetchData();
  }, [tableParams.pagination.current, tableParams.field, tableParams.order, filter, refreshTable]);

  const fetchData = async () => {
    setLoading(true);
    let params = {
      filter: filter,
      startRow: getAllData ? null : (tableParams.pagination.current - 1) * tableParams.pagination.pageSize,
      endRow: getAllData ? null : tableParams.pagination.current * tableParams.pagination.pageSize,
    };

    await api.get(`/${table}/getall`, { params }).then(response => {
      if (!response.data.status) {
        toast.error('Failed to get Data');
      } else {
        setData(response.data);
        setLoading(false);
        setTableParams(prev => ({
          ...prev,
          pagination: { ...prev.pagination, total: response.data.totalRecords, showSizeChanger: false }
        }));
      }
    });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({ pagination, filters, ...sorter });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys) => {
      setCheckedArray(selectedRowKeys);
    },
  };

  return (
    <div style={{ userSelect: 'none' }}>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: '#39aaa5',
              headerColor: 'white',
              rowHoverBg: '#bcdffb',
            },
          },
        }}
      >
        <Table
          className={height ? 'ant_table_mini' : 'ant_table'}
          columns={columnDefs}
          rowSelection={selection ? { type: 'checkbox', ...rowSelection } : null}
          rowKey={(record) => record.id}
          dataSource={data ? data.data : []}
          loading={loading}
          onChange={handleTableChange}
          scroll={{ y: height ? '53vh' : '66vh' }}
          size="small"
          pagination={{
            ...tableParams.pagination,
            itemRender: (current, type, originalElement) => {
              if (type === 'prev') {
                return <IoIosArrowBack size={20} style={{ marginRight: '12px' }} />;
              }
              if (type === 'next') {
                return <IoIosArrowForward size={20} style={{ marginLeft: '12px' }} />;
              }
              return originalElement;
            },
            showTotal: (total) => (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <div>{tableFooter}</div>
                <div>{`Total:  ${total} items`}</div>
                <div style={{ position: 'absolute', left: '8px', bottom: '-10px' }}>
                  <DropdownButton drop={'up'} title={<BiExport size={30} color={'#2b7b76'} />} size={'sm'} variant="white">
                    <Dropdown.Item eventKey="1" onClick={() => exportToExcel(getExcelData(data?.data, data?.summary), title)}>Excel .xlsx</Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item eventKey="2" onClick={() => setShowReportModal(!showReportModal)}>Report .pdf</Dropdown.Item>
                  </DropdownButton>
                </div>
              </div>
            ),
          }}
          rowClassName={(record, index) => (rowColor ? rowColor(record, index) : index % 2 === 0 ? 'even-row' : 'odd-row')}
        />
      </ConfigProvider>

      <ReportModal showModal={showReportModal} toggleModal={() => setShowReportModal(!showReportModal)} api={api} report={report} reportRef={reportRef} />
    </div>
  );
};

export default SalesSimpleTable;
